<template>
  <f7-panel
    right
    cover
    resizable
    close-by-backdrop-click
    :backdrop="false"
    class="loginPanel"
    v-if="authenticated"
    :style="{
      'border-left':
        'var(--f7-page-master-border-width) solid var(--f7-page-master-border-color)',
      width: '260px',
    }"
  >
    <f7-page>
      <f7-navbar no-shadow>
        <f7-nav-left>
          <f7-link href="/user/profile" panel-close>
            <img
              v-if="userAccount && userAccount.avatar !== null"
              :src="userAccount.avatar"
              class="panel-avatar"
              :alt="$t('common.a11y.userAvatarOrLogo')"
            />
            <f7-badge
              v-else
              color="auto"
              class="elevation-1 panel-avatar-badge"
              slot="media"
              >{{ $filtersGetInitial.getInitial(userAccount.name) }}</f7-badge
            >
          </f7-link>
        </f7-nav-left>
        <f7-nav-title href="/user/profile" v-if="profile">{{
          profile.given_name
        }}</f7-nav-title>
        <f7-nav-right>
          <f7-link panel-close>
            <f7-icon ios="f7:multiply" aurora="f7:multiply" md="material:close"></f7-icon
          ></f7-link>
        </f7-nav-right>
      </f7-navbar>

      <f7-list dividers-ios strong-ios inset>
        <f7-list-item
          link="/user/profile"
          panel-close
          :title="$t('dashboard.goToMyProfile')"
        >
          <template #media>
            <img
              v-if="userAccount && userAccount.avatar !== null"
              :src="userAccount.avatar"
              class="panel-avatar"
              :alt="$t('common.a11y.userAvatarOrLogo')"
            />
            <f7-badge
              v-else
              color="auto"
              class="elevation-1 panel-avatar-badge"
              slot="media"
              >{{ $filtersGetInitial.getInitial(userAccount.name) }}</f7-badge
            ></template
          >
        </f7-list-item>
        <f7-list-item
          small
          outline
          raised
          link=""
          :title="$t('common.logout')"
          @click="logout()"
          panel-close
          class="logout-item"
          ><template #media>
            <f7-icon
              class="logout-item"
              ios="f7:square_arrow_left"
              aurora="f7:square_arrow_left"
              md="material:exit_to_app"
            ></f7-icon>
          </template>
        </f7-list-item>
         <ThemeSettingRow />
        <f7-list-item
          link="/recipients"
          panel-close
          :title="$t('panel-right.myRecipients')"
        ></f7-list-item>
        <f7-list-item
          link="/dashboard/"
          panel-close
          :title="$t('panel-right.myDashboard')"
        ></f7-list-item>
        <f7-list-item
          panel-close
          link="/topup/my-account"
          :title="$t('panel-right.topMeUp')"
        ></f7-list-item>
        <f7-list-item divider></f7-list-item>
        <f7-list-item
          panel-close
          link="/tontines"
          :title="$t('panel-right.myTontines')"
        ></f7-list-item>
        <f7-list-item
          panel-close
          link="/groups/"
          :title="$t('panel-right.myWallets')"
        ></f7-list-item>
       

        <br />
      </f7-list>
    </f7-page>
  </f7-panel>
</template>
<script setup>
import { computed } from "vue";
import { useAccountStore } from "../js/pinia-stores/account.js";
import { useAuthStore } from "../js/pinia-stores/auth.js";
import { useLogin } from "@/js/composables/useLogin.js";
import ThemeSettingRow from "../components/common/ThemeSettingRow.vue";

const { logoutFn } = useLogin();

const userAccount = computed(() => useAccountStore().userAccount);
const profile = computed(() => useAuthStore().profile);
const authenticated = computed(() => useAuthStore().authenticated);

function logout() {
  logoutFn();
}
</script>
<style scoped>
.panel-avatar {
  width: 28px;
  height: 28px;
  background-size: cover;
  display: block;
  border-radius: 50%;
}

.panel-avatar-badge {
  height: 28px;
  width: 28px;
  min-width: 28px;
  border-radius: 50%;
}

.md .panel-avatar-badge {
  height: 32px;
  width: 32px;
  min-width: 32px;
}

.logout-item {
  color: red;
}
</style>